import { useData } from '../../contexts/DataContext'
import { useFilters } from '../../contexts/FilterContext'

function CategorySelector() {
  const { config } = useData()
  const { activeCategory, setCategory } = useFilters()

  if (!config?.facility_types) {
    return null
  }

  return (
    <div className="flex items-center space-x-4">
      <span className="text-sm font-medium text-gray-700">Category:</span>
      <div className="flex space-x-2">
        {config.facility_types.map(type => (
          <button
            key={type.id}
            onClick={() => setCategory(type.id)}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              activeCategory === type.id
                ? 'bg-primary-500 text-white shadow-sm'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            {type.name}
          </button>
        ))}
      </div>
    </div>
  )
}

export default CategorySelector
